import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface MainReducerState {
  pushNotificationsEnabled: boolean;
  subsequentStart: boolean;
}

const INITIAL_STATE = {
  pushNotificationsEnabled: false,
  subsequentStart: false,
} as MainReducerState;

const slice = createSlice({
  name: "main",
  initialState: INITIAL_STATE,
  reducers: {
    setPushNotificationsEnabled: (state, action: PayloadAction<boolean>) => {
      state.pushNotificationsEnabled = action.payload;
    },
    setSubsequentStart: (state, action: PayloadAction<boolean>) => {
      state.subsequentStart = action.payload;
    },
  },
});

export const { setSubsequentStart, setPushNotificationsEnabled } =
  slice.actions;

const reducer = slice.reducer;
export default reducer;
